const store = window.sessionStorage;
export const AUTH_TOKEN_KEY = "auth-token";
export const REFRESH_TOKEN_KEY = "refresh-token";
export const AUTH_FLOW_KEY = "auth-flow-data";

export function getItem(key) {
  return store.getItem(key);
}

export function setItem(key, value) {
  store.setItem(key, value);
}

export function clear() {
  store.clear();
}

export function getObject(key) {
  try {
    const rawData = getItem(key);
    return rawData ? JSON.parse(rawData) : {};
  } catch (error) {
    console.error(`Error while getting data from session storage [${key}]`);
    return null;
  }
}

export function setObject(key, value) {
  try {
    setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error(`Error while setting from session storage [${key}]`);
  }
}

export function removeObject(key) {
  try {
    store.removeItem(key);
  } catch (error) {
    console.error(`Error while removing data from session storage [${key}]`);
  }
}
